export const width=1360;export const height=821;export default{width:width,height:height};